import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { useNavigation } from "../../utils/navigation";
import { AuthUserContext } from "../../context/AuthUserContext";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: var(--bg-200);
  width: 100%;
`;
const RadioButton = styled.div`
  margin: var(--spacing-md);
  min-width: 16px;
  min-height: 16px;
  max-width: 16px;
  max-height: 16px;
  border-radius: 20px;
  border: 1px solid var(--primary-200);

  display: none;
  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
const CheckedRadio = styled.div`
  background-color: var(--primary-200);
  width: 8px;
  height: 8px;
  border-radius: 20px;
`;

const LeftDiv = styled.div`
  margin: 0 auto;
  width: 90%;
  max-width: 90%;
`;

const P = styled.p`
  font-size: var(--font-size-small);
  line-height: var(--font-size-large);
  font-weight: 500;
`;

const AddressType = styled.p`
  font-size: var(--font-size-small);
  font-family: "Larken";
  margin-top: 0;
  border: 1px solid var(--text-200);
  padding: var(--spacing-xs) var(--spacing-md);
  border-radius: 20px;
  text-transform: capitalize;
  color: ${({ $isActive }) =>
    $isActive ? "var(--accent-200)" : "var(--text-200)"};

  border-color: ${({ $isActive }) =>
    $isActive ? "var(--accent-200)" : "var(--text-200)"};
  background-color: var(--bg-100);
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (min-width: 767px) {
    width: calc(100% - 8px);
  }
  @media (min-width: 768px) and (max-width: 1040px) {
    width: 100%;
  }
`;
const FormDiv = styled.div`
  width: 100%;
  min-width: 100%;
  @media (min-width: 767px) {
    display: flex;
    gap: 24px;
  }
`;
const FormPart = styled.div``;
const FormFlex = styled.div`
  display: flex;
  gap: var(--spacing-xxs);
  width: calc(100%);
  align-items: flex-start;

  @media (min-width: 767px) {
    width: calc(100% + 8px);
    gap: var(--spacing-md);
  }
`;

const Input = styled.input`
  flex: 3;
  width: 100%;
  margin-bottom: var(--spacing-md);
  padding: var(--spacing-sm) 0 var(--spacing-sm) var(--spacing-xs);
  border: 1px solid #d0d5dd;
  &::placeholder {
  }
  &:disabled {
    background-color: var(--bg-300);
    cursor: not-allowed;
  }

  background-color: var(--bg-100);
`;
const SmallInput = styled(Input)`
  flex: 1;
  width: calc(100% - 8px);
`;
const SmallInputDesktop = styled(SmallInput)`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`;
const SmallInputMB = styled(SmallInput)`
  display: block;
  @media (min-width: 767px) {
    display: none;
  }
`;

const Button = styled.button`
  border-radius: 0;
  width: 100%;
  white-space: nowrap;
  @media (min-width: 767px) {
    width: 200px;
  }
`;
const CancelButton = styled(Button)`
  width: auto;
  background-color: var(--bg-200);
  border: none;
  color: var(--text-200);
  &:hover {
    color: var(--primary-200);
    background-color: var(--bg-200);
  }
  display: none;
  @media (min-width: 768px) {
    display: inline-block;
  }
`;
const LocationButton = styled.button`
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-xs);
  padding: var(--spacing-xs);
  margin: var(--spacing-md) 0;
  width: 100%;

  @media (min-width: 768px) {
    width: auto;
  }
`;

const RegisterAddressBook = ({ addressData, setAddressData }) => {
  const { t } = useTranslation();

  const handleChange = (field, value) => {
    setAddressData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <Container>
      <LeftDiv>
        <Form>
          <FormPart>
            <Input
              type="text"
              placeholder={t("LABELS.COUNTRY")}
              value={addressData.country}
              onChange={(e) => handleChange("country", e.target.value)}
              required
            />

            <FormFlex>
              <SmallInput
                type="text"
                placeholder={t("LABELS.POSTAL_CODE")}
                value={addressData.postal_code}
                onChange={(e) => handleChange("postal_code", e.target.value)}
                required
              />
              <Input
                type="text"
                placeholder={t("LABELS.CITY")}
                value={addressData.city}
                onChange={(e) => handleChange("city", e.target.value)}
                required
              />
            </FormFlex>

            <FormFlex>
              <Input
                type="text"
                placeholder={t("LABELS.STREET")}
                value={addressData.street_name}
                onChange={(e) => handleChange("street_name", e.target.value)}
                required
              />
              <SmallInput
                type="text"
                placeholder={t("LABELS.STREET_NUMBER")}
                value={addressData.number}
                onChange={(e) => handleChange("number", e.target.value)}
                required
              />
            </FormFlex>

            <FormFlex>
              <Input
                type="text"
                placeholder={`${t("LABELS.EXTENSION")} (${t(
                  "LABELS.OPTIONAL"
                )})`}
                value={addressData.extension}
                onChange={(e) => handleChange("extension", e.target.value)}
              />
            </FormFlex>
          </FormPart>
        </Form>
      </LeftDiv>
    </Container>
  );
};

export default RegisterAddressBook;
